import * as React from 'react';
import { reduxForm } from 'redux-form';
import { AgreementPageWithFormProps } from '../ClientAgreement';
import ContentContainer, { formSelector } from '../ContentContainer/Content';
import { connect } from 'react-redux';
import agreementStyles from '../ClientAgreement.module.css';

const AgreementPage5 = (props: AgreementPageWithFormProps) => (
  <ContentContainer {...props} requiredSignatures="clientOnly" currentPage={5} noScroll>
    <div className={agreementStyles.contentHeader}>
      Exhibit 2<br />
      Authorization for Ascend to Communicate with Creditors and Collections Agencies
      <br />
      <br />
    </div>
    I have engaged Ascend Debt Relief PLLC (“Ascend”), to assist me in arranging for the settlement of my
    unsecured debt. I expressly give the following permission to Ascend, its agents, affiliates,
    representatives and assigns for the purpose of assisting Ascend in carrying out its obligations
    pursuant to the Client Services Agreement between Ascend and me.
    <br />
    <br />
    This authorization is being done to grant permission to Ascend to communicate with my creditors,
    to whom I understand and acknowledge that I remain obligated. All communications done by Ascend
    are done with my express permission and instruction. Please direct all communications concerning
    my debt and obligations to Ascend.
    <br />
    <br />
    In accordance therewith, I instruct and authorize Ascend as follows:
    <ol>
      <li>
        To communicate with, negotiate and settle debts as fully, completely and to the same extent
        I am or would be able to do so on my own behalf, with all banks, creditors, financial
        institutions, licensed collection agencies, and/or any and all other related entities and
        creditors relating to my outstanding debts and the specific obligations that Ascend has
        undertaken pursuant to my Client Services Agreement with Ascend; and
      </li>
      <br />
      <li>
        To obtain all records, debt validations and support for the debts allegedly owed on my
        behalf and to obtain my credit report(s) to verify all outstanding debts and amounts owed.
      </li>
    </ol>
    <br />
    Ascend has my full authority to discuss any and all details of my financial situation with any
    third party or affiliate working on Ascend's behalf, as well as with all outstanding Creditors.
  </ContentContainer>
);

const form = reduxForm({
  form: 'clientAgreement',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(AgreementPage5 as any);

export default connect(state => ({
  name: formSelector(state, 'name'),
  existingSignature: formSelector(state, 'clientSignature')
}))(form) as any;
